import { BrowserName } from "./user-agent-info.types";
let info;
function parseUserAgent() {
    var _a, _b, _c;
    let browserName = BrowserName.unknown;
    let match = navigator.userAgent.match(/(CrOS \w+|Windows NT|Mac OS X|Linux|Android) ([\d._]+)?/);
    const os = (_a = (match !== null && match !== void 0 ? match : [])[1]) !== null && _a !== void 0 ? _a : "Unknown";
    const osVersion = (_b = (match !== null && match !== void 0 ? match : [])[2]) !== null && _b !== void 0 ? _b : "Unknown";
    const chromeMatch = navigator.userAgent.match(/(?:Chrome|Version)\/([\d.]+)/);
    const edgeMatch = navigator.userAgent.match(/(?:Edg|Version)\/([\d.]+)/);
    const firefoxMatch = navigator.userAgent.match(/(?:Firefox)\/([\d.]+)/);
    const operaMatch = navigator.userAgent.match(/(?:OPR|Version)\/([\d.]+)/);
    if (edgeMatch) {
        match = edgeMatch;
        browserName = BrowserName.edge;
    }
    else if (firefoxMatch) {
        match = firefoxMatch;
        browserName = BrowserName.firefox;
    }
    else if (operaMatch) {
        match = operaMatch;
        browserName = BrowserName.opera;
    }
    else if (chromeMatch) {
        match = chromeMatch;
        browserName = BrowserName.chrome;
    }
    const browserVersion = (_c = (match !== null && match !== void 0 ? match : [])[1]) !== null && _c !== void 0 ? _c : "Unknown";
    return {
        browserName,
        os,
        osVersion,
        browserVersion,
    };
}
export function getUserAgentInfo() {
    if (!info) {
        info = parseUserAgent();
    }
    return info;
}
